import { Route, Routes } from 'react-router-dom'

import Overview from './screens/Overview'

const AnalyticsRoutes = () => (
  <Routes>
    <Route path="/" element={<Overview />} />
  </Routes>
)

export default AnalyticsRoutes
